import { render, staticRenderFns } from "./TambahMenuMobile.vue?vue&type=template&id=74b4181b&scoped=true"
import script from "./TambahMenuMobile.vue?vue&type=script&lang=js"
export * from "./TambahMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./TambahMenuMobile.vue?vue&type=style&index=0&id=74b4181b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4181b",
  null
  
)

export default component.exports